// extracted by mini-css-extract-plugin
export var post = "PostList-module--post--e36hV";
export var postDate = "PostList-module--post-date--oeOkF";
export var postTitle = "PostList-module--post-title--FgK7Q";
export var root = "PostList-module--root--QDzx+";